import _debug from "debug";

export const debug = _debug("@bared/app");
